import React from 'react';
import { Divider as WebDivider } from '@medely/web-components';

export const Divider = () => {
  return <WebDivider />;
};
